module.exports = __webpack_public_path__ + "static/media/enrollment_bg_xl.1ded918a.jpg";